module.exports = __webpack_public_path__ + "img/300.0f4caeab.png";